import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gridGap: theme.spacing(1),
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  originCard: {
    transition: theme.transitions.create(['box-shadow', 'filter'], {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
    '&:hover': {
      boxShadow: theme.shadows[2],
      filter: 'brightness(0.90)',
    },
  },
  disabledCard: {
    opacity: 0.5,
    pointerEvents: 'none',
    filter: 'grayscale(0.5)',
  },
  contentCard: {
    padding: 0,
    border: 0,
    width: '100%',
    height: '100%',
  },
  gridItem: {
    transition: theme.transitions.create(['flex-basis', 'max-width'], {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  iframeContainer: {
    width: 447,
    height: 252,
    aspectRatio: '16/9',
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 200,
    },
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  card: {
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(2),
    paddingBlock: theme.spacing(2),
    gap: theme.spacing(2),
    height: 252,
    borderRadius: 4,
    textAlign: 'justify',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  selectedCard: {
    background: `linear-gradient(to right, ${theme.palette.primary.main} 50%, ${theme.palette.primary.hover} 100%)`,
  },
  numberBox: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    borderRadius: '100%',
    width: 'fit-content',
    height: 'fit-content',
  },
  number: {
    lineHeight: 'normal',
  },
  checkIcon: {
    marginTop: 4,
  },
  scrollContainer: {
    '& .ps__rail-y': {
      background: 'transparent !important',
    },
  },
}))

export default styles
